<template>
  <v-container :fill-height="false" class="start" fluid pt-0>

    <v-app-bar app color="black" dark fixed>
      <template v-if="$vuetify.breakpoint.mdAndDown">
        <hb-main-menu-button/>
      </template>
      <v-toolbar-title></v-toolbar-title>

      <v-spacer></v-spacer>

    </v-app-bar>
    <template v-if="showNoPermissions">
      <no-permissions-view/>
    </template>
  </v-container>
</template>

<script>

import NoPermissionsView from "../components/NoPermissionsView";

const redirects = [
  {
    roles: [],
    to: {name: 'strategia'},
  },
  /*{
    roles: ['tehtaantarkastus'],
    to: {name: 'tarkastusPyynnot'},
  },
  {
    roles: ['kehu.suunnittelu'],
    to: {name: 'suunnittelu'},
  },
  {
    roles: ['kehu.tehtavat'],
    to: {name: 'tehtavat'},
  },
  {
    roles: ['kehu.asennus'],
    to: {name: 'asennus'},
  }*/
]

export default {
  name: 'StartView',
  components: {NoPermissionsView},
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  computed: {
    showNoPermissions() {
      return this.matchingRedirect == null;
    },
    matchingRedirect() {
      return redirects[0];
      const userRoles = this.$user.permissions.filter(p => p.enabled).map(r => r.role);
      for (let redirect of redirects) {
        if (userRoles.some(r => redirect.roles.includes(r))) {
          return redirect;
        }
      }

      return null;
    }
  },
  mounted() {
    const redirect = this.matchingRedirect;
    if (redirect) {
      this.$router.replace(redirect.to);
    }
  },
};
</script>

<style scoped></style>
